import React, { useState } from 'react';
import ChatList from './ChatList';
import GroupsList from './GroupsList';

const Sidebar = ({
    privateChats,
    groups,
    currentChatId,
    currentChatType,
    onChatSelect,
    onCreateGroup,
    onOpenSettings,
    user
}) => {
    const [activeTab, setActiveTab] = useState('chats');
    const [searchTerm, setSearchTerm] = useState('');

    const filteredChats = privateChats.filter(chat =>
        chat.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const filteredGroups = groups.filter(group =>
        group.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 style={{ fontSize: '1.5rem', margin: 0, background: 'var(--primary-gradient)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                        <i className="fas fa-leaf" style={{ background: 'none', WebkitTextFillColor: 'var(--primary)' }}></i> Echo
                    </h2>
                    <button className="btn-primary btn-sm" onClick={onCreateGroup} style={{ padding: '0.5rem 0.8rem' }}>
                        <i className="fas fa-plus"></i>
                    </button>
		    <button className="btn-icon" onClick={onOpenSettings} style={{ marginLeft: '0.5rem' }}>
		        <i className="fas fa-cog"></i>
		    </button>
                </div>

                <div className="chat-tabs">
                    <button
                        className={`tab-btn ${activeTab === 'chats' ? 'active' : ''}`}
                        onClick={() => setActiveTab('chats')}
                    >
                        <i className="fas fa-comment"></i> Чаты
                    </button>
                    <button
                        className={`tab-btn ${activeTab === 'groups' ? 'active' : ''}`}
                        onClick={() => setActiveTab('groups')}
                    >
                        <i className="fas fa-users"></i> Группы
                    </button>
                </div>

                <div className="input-group" style={{ marginTop: '0.75rem' }}>
                    <input
                        type="text"
                        placeholder="Поиск..."
                        className="message-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ borderWidth: '1px' }}
                    />
                </div>
            </div>

            {activeTab === 'chats' && (
                <ChatList
                    chats={filteredChats}
                    currentChatId={currentChatId}
                    currentChatType={currentChatType}
                    onChatSelect={onChatSelect}
                />
            )}

            {activeTab === 'groups' && (
                <GroupsList
                    groups={filteredGroups}
                    currentChatId={currentChatId}
                    currentChatType={currentChatType}
                    onGroupSelect={onChatSelect}
                />
            )}
        </div>
    );
};

export default Sidebar;
